// extracted by mini-css-extract-plugin
export default {"accent_picker_wrapper":"label-accent-picker_accent_picker_wrapper__pj0-m","accent_box":"label-accent-picker_accent_box__XEnqS"};